/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Application_Already_AcceptedInputs */

const en_application_already_accepted = /** @type {(inputs: Application_Already_AcceptedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`This application is already accepted.`)
};

const de_application_already_accepted = /** @type {(inputs: Application_Already_AcceptedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Diese Bewerbung ist bereits angenommen.`)
};

/**
* | output |
* | --- |
* | "This application is already accepted." |
*
* @param {Application_Already_AcceptedInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const application_already_accepted = /** @type {((inputs?: Application_Already_AcceptedInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Application_Already_AcceptedInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_application_already_accepted(inputs)
	return en_application_already_accepted(inputs)
});